import { render, staticRenderFns } from "./CurriculumSelectbox.vue?vue&type=template&id=2596ab98"
import script from "./CurriculumSelectbox.vue?vue&type=script&lang=js"
export * from "./CurriculumSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports